import { createContext } from "react";
import BookingStore from './index'

const store = new BookingStore();
const BookingStoreContext = createContext<BookingStore>(store);
export default BookingStoreContext;
